const FLOOR_PX = 14;
const STEP_PX = 0.5;

const fitText = (el, floor) => {
    el.style.fontSize = '';

    const ceiling = parseFloat(getComputedStyle(el).fontSize);

    if (!ceiling || ceiling <= floor) {
        return;
    }

    let size = ceiling;

    while (el.scrollHeight > el.clientHeight + 1 && size - STEP_PX >= floor) {
        size -= STEP_PX;
        el.style.fontSize = `${size}px`;
    }
};

document.addEventListener('alpine:init', () => {
    Alpine.directive('fit-text', (el, { modifiers }, { cleanup }) => {
        const floorIndex = modifiers.indexOf('min');
        const floor = floorIndex !== -1 && modifiers[floorIndex + 1]
            ? parseFloat(modifiers[floorIndex + 1])
            : FLOOR_PX;

        const fit = () => fitText(el, floor);

        fit();

        let lastWidth = el.clientWidth;

        const resizeObserver = new ResizeObserver(() => {
            if (el.clientWidth === lastWidth) {
                return;
            }

            lastWidth = el.clientWidth;
            fit();
        });

        resizeObserver.observe(el);

        const mutationObserver = new MutationObserver(fit);

        mutationObserver.observe(el, { childList: true, characterData: true, subtree: true });

        document.fonts?.ready?.then(fit);

        cleanup(() => {
            resizeObserver.disconnect();
            mutationObserver.disconnect();
        });
    });
});
